import { AgentGroup } from "../../shared/model/AgentGroup";
import { HashMap } from "../../shared/model/HashMap";

import { AgentStatusPerAgentAndProcess } from "./AgentStatusPerAgentAndProcess";
import { CleanOldVersionsDialogState } from "./CleanOldVersionsDialogState";
import { ConfirmDeleteDialogState } from "./ConfirmDeleteDialogState";
import { DeployDialogState } from "./DeployDialogState";
import { ListState } from "./ListState";
import { LogLevelDialogState } from "./LogLevelSetting";
import { LogRetentionUsageData, LogLevelUsageData } from "./LogLevelAndRetentionUsageModel";
import { Draft, IProcessReferenceData, Process } from "./Process";
import { ProcessCountState } from "./ProcessCountState";
import { ProcessVariablesEditorState } from "./ProcessVariablesEditorState";
import { RunOnceDialogState } from "./RunOnceDialogState";
import { TaskModel } from "./Search";

export interface State {
    processes: Process[];
    processCount: number;
    drafts: Draft[];
    agentGroups: HashMap<AgentGroup>;
    agentStatuses: AgentStatusPerAgentAndProcess;
    processCounts: ProcessCountState;
    currentAgentGroupName: string;
    listState: ListState;
    availableTags: string[];
    deployDialogState: DeployDialogState;
    runOnceDialogState: RunOnceDialogState;
    loading: string[];
    isSubprocessList: boolean;
    logLevelDialogState: LogLevelDialogState;
    tasks: TaskModel[];
    userPermissions: HashMap<boolean>;
    confirmDeleteDialogState: ConfirmDeleteDialogState;
    referencedProcessMap: HashMap<IProcessReferenceData[]>;
    usedInProcessesMap: HashMap<HashMap<string[]>>;
    usedProcessesMap: HashMap<HashMap<string[]>>;
    cleanOldVersionsDialogState: CleanOldVersionsDialogState;
    processVariablesEditorState: ProcessVariablesEditorState;
    environmentVariables: string[];
    logLevelUsage: LogLevelUsageData;
    logRetentionUsage: LogRetentionUsageData;
}

export function getCurrentAgentGroup(state: State) {
    if (!state.currentAgentGroupName) {
        throw Error("No current agent group name set");
    }
    return getAgentGroup(state, state.currentAgentGroupName);
}

export function getAgentGroup(state: State, agentGroupName: string) {
    const agentGroup = state.agentGroups[agentGroupName];
    if (!state.agentGroups) {
        throw Error(`No agent group data found for '${agentGroupName}'`);
    }
    return agentGroup;
}
